import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { putCustomerOrderChargesInfoUpdate } from "../../services/OrderEdit/orderInfoEdit";
import { getStoreLocalData } from "../../utils/localStorage";

const BookingInfoChargesEdit = ({
  bookingInfoChargesEditModalVisible,
  setBookingInfoChargesEditModalVisible,
  sendDataToBookingInfoChargesEdit,
  storeCustomerId,
  bookingOrderId,
  storeId,
  chargeAmountPreviousValue,
}) => {
  const [customChargeValue, setCustomChargeValue] = useState('');
  const [selectedChargeAmount, setSelectedChargeAmount] = useState('');
  const [customChargeCountValue, setCustomChargeCountValue] = useState('1');

  const { storeLocalData } = getStoreLocalData();

  useEffect(() => {
    // Check if selectedPackageItemValue is available
    const roundOffValue = chargeAmountPreviousValue?.amount?.toFixed(0);
    const chargeDiscountAmountValue =
      chargeAmountPreviousValue?.chargeDiscountAmount?.toFixed(0);
    const countValue = chargeAmountPreviousValue?.count?.toFixed(0);
    setCustomChargeValue(roundOffValue?.toString());
    setSelectedChargeAmount(chargeDiscountAmountValue?.toString());
    setCustomChargeCountValue(countValue?.toString());
  }, [chargeAmountPreviousValue]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState('');
  const [errorText, setErrorText] = useState('');


  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [showUpdateButton, setShowUpdateButton] = useState(false);


  const handleChargeAmountChange = text => {
    if (!text) {
      setSelectedChargeAmount('');
      setErrorText('Charge cannot be empty or zero');
      setIsSubmitButtonPressed(true);
    } 
    // else if (
    //   parseInt(text) >
    //   parseInt(chargeAmountPreviousValue?.chargeDiscountAmount?.toFixed(0))
    // ) {
    //   setErrorText(
    //     'Entered Value Can Not Be Greater Then ' +
    //       chargeAmountPreviousValue?.chargeDiscountAmount?.toFixed(0),
    //   );
    //   setSelectedChargeAmount(text);
    //   setIsSubmitButtonPressed(true);
    // } 
    else {
      setSelectedChargeAmount(text);
      const newChargeValue =
        parseInt(text) * parseInt(customChargeCountValue).toFixed(0);
      // customChargeValue,
      setCustomChargeValue(newChargeValue);
      setErrorText('');
      setIsSubmitButtonPressed(false);
    }
  };


  const handleChargeCountChange = text => {
    if (!text) {
      setCustomChargeCountValue('');
      setErrorText('Count Count cannot be empty or zero');
      setIsSubmitButtonPressed(true);
    } else if (parseInt(text) <= parseInt(0)) {
      setErrorText("Count Can't Be Less Then Or Equal to Zero");
      setCustomChargeCountValue(text);
      setIsSubmitButtonPressed(true);
    } else {
      setCustomChargeCountValue(text);
      const newChargeValue =
        parseInt(text) *
        parseInt(selectedChargeAmount)
        // parseInt(chargeAmountPreviousValue?.chargeDiscountAmount?.toFixed(0));
      // customChargeValue,
      setCustomChargeValue(newChargeValue);
      setErrorText('');
      setIsSubmitButtonPressed(false);
    }
  };


  const handleConfirmation = () => {
    if (!errorText) {
      setIsSubmitButtonPressed(true);
      const data = {
        ...chargeAmountPreviousValue,
        amount: parseInt(customChargeValue),
        count: parseInt(customChargeCountValue).toFixed(0),
      };


      putCustomerOrderChargesInfoUpdate(
        storeCustomerId,
        storeId,
        bookingOrderId,
        data,
      )
        .then(response => {
          if (!response.data.error) {
            const Res = response.data;
            const message = Res.message;
            const status = Res.status;
            sendDataToBookingInfoChargesEdit({
              success: status,
            });
            setIsSubmitButtonPressed(false);
            setBookingInfoChargesEditModalVisible(false);
            setCustomChargeCountValue('');
            setSelectedChargeAmount("");
          }
        })
        .catch(err => {
          console.error('Error:', err);
        });
    }
    setShowUpdateButton(true);
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
          setBookingInfoChargesEditModalVisible(false);
          setErrorText('');
          setShowUpdateButton(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={bookingInfoChargesEditModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!bookingInfoChargesEditModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
          className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
             <div>
                <div  className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
                  style={{
                    backgroundImage:
                      "radial-gradient(circle at left top, #2B70D7, #1752AA)",
                  }}>
                  <div></div>

                  <p className=" text-4xl text-primary-50 font-semibold">
                    Charge Amount
                  </p>
                  <Button
                    label="x"
                    onClick={(e) => hide(e)}
                    text
                    className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
                  ></Button>
                </div>

                <div className="mt-3 mx-4">
                  <div className="flex flex-row justify-content-between">
                    <div>
                      <p className=" text-xl font-semibold">Charge</p>
                    </div>
                    <div>
                      <p className=" text-xl font-semibold">Count</p>
                    </div>
                    <div>
                      <p className=" text-xl font-semibold">Total</p>
                    </div>
                  </div>
                </div>
                <div className="mt-2 mb-2 mx-4">
                  <div className="flex flex-row justify-content-between gap-4">
                  <div className="border-round-xl shadow-4">
                      <InputText
                        placeholder="amount"
                        value={selectedChargeAmount}
                        maxLength={50}
                        onChange={(e) =>
                          handleChargeAmountChange(e.target.value)
                        }
                        className="w-full border-none px-3 text-md "
                      ></InputText>
                    </div>

                    <div className="border-round-xl shadow-4">
                      <InputText
                        placeholder="amount"
                        value={customChargeCountValue}
                        maxLength={50}
                        onChange={(e) =>
                          handleChargeCountChange(e.target.value)
                        }
                        className=" w-full border-none px-3 text-md "
                      ></InputText>
                    </div>

                    <div className="flex justify-content-center align-items-center"
                    >
                      <p className=" text-xl font-semibold">
                      {storeLocalData?.currencySymbol}{customChargeValue}
                      </p>
                    </div>
                  </div>
                </div>

                {errorText && (
                  <div
                    style={{
                      marginTop: 2,
                      marginBottom: 10,
                      alignSelf: "center",
                    }}
                  >
                    <p style={{color:"red"}}>{errorText}</p>
                  </div>
                )}
              </div>

             
                <Button
                   
                  disabled={isSubmitButtonPressed}
                  onClick={handleConfirmation}
                   
                  className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Update
                </p></Button>
             
            
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default BookingInfoChargesEdit;
